export default "__VITE_ASSET__f8635cfd__"